import type { ReactNode } from 'react';

import copy from 'copy-to-clipboard';

import { getTestProps } from '../../lib/helpers';

interface CopyButtonProps {
  /**
   * Text copied to the clipboard
   */
  text: string;
  /**
   * Button contents
   */
  children: ReactNode;
  /**
   * Callback called after copying succeeds
   */
  onCopy?: (text: string) => void;
  /**
   * Test ID for the button
   */
  testId?: string;
}

const CopyButton = ({ text, onCopy, children, testId }: CopyButtonProps) => {
  const handleClick = async () => {
    const copied = await copy(text);
    if (copied) {
      onCopy?.(text);
    }
  };

  return (
    <button
      type="button"
      className={
        'block cursor-copy appearance-none border-0 bg-transparent p-0 text-left text-inherit ' +
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue'
      }
      onClick={handleClick}
      {...getTestProps(testId)}
    >
      {children}
    </button>
  );
};

export default CopyButton;
